/**
 * Team Check-Ins (Performance) — leader quick-start tour.
 * Step-by-step walkthrough of the review → acknowledge flow.
 */

export const TEAM_CHECKINS_TOUR_ID = "team-checkins-v3";

export const TEAM_CHECKINS_TOUR_STEPS = [
  {
    id: "intro",
    route: "/people/team-checkins",
    selector: "[data-tour='team-checkins-header']",
    title: "1. Team Check-Ins",
    description:
      "This is where leaders review direct reports' monthly check-ins under Performance. You will open a submitted check-in, record the 1:1, and close it.",
    placement: "bottom",
  },
  {
    id: "period",
    route: "/people/team-checkins",
    selector: "[data-tour='team-checkins-period']",
    title: "2. Pick the period",
    description:
      "Choose the year, quarter, and month you are reviewing. Leaders usually review the previous month after it closes.",
    placement: "bottom",
  },
  {
    id: "team-list",
    route: "/people/team-checkins",
    selector: "[data-tour='team-checkins-table']",
    title: "3. Find Pending review",
    description:
      "When someone submits, Check-in shows Submitted and Review shows Pending review. Click Review to open their check-in.",
    placement: "bottom",
  },
  {
    id: "employee-checkin",
    route: "/people/team-checkins",
    selector: "[data-tour='team-checkins-employee-checkin']",
    title: "4. Read their check-in",
    description:
      "Review each objective status and notes the employee submitted. This section is read-only — it is their update for the month.",
    placement: "top",
  },
  {
    id: "leader-form",
    route: "/people/team-checkins",
    selector: "[data-tour='team-checkins-leader-form']",
    title: "5. Record the 1:1",
    description:
      "Enter the 1:1 meeting date and add review notes from what you discussed — blockers, next steps, coaching.",
    placement: "top",
  },
  {
    id: "send-acknowledge",
    route: "/people/team-checkins",
    selector: "[data-tour='team-checkins-actions']",
    title: "6. Send & Acknowledge",
    description:
      "Click Send & Acknowledge to close your review and notify the employee. Use Save draft if you need to finish later.",
    placement: "top",
  },
  {
    id: "employee-ack",
    route: "/people/team-checkins",
    selector: "[data-tour='team-checkins-ack-record']",
    title: "7. Employee acknowledges",
    description:
      "On My Check-In the employee sees your notes and clicks I acknowledge this review. Both views keep a record of who acknowledged, with date and time.",
    placement: "top",
  },
];
